import { Mail, Globe, Facebook, Instagram, Twitter } from "lucide-react";
import SunMark from "./SunMark";

const socials = [
  { name: "Facebook", Icon: Facebook, href: "#" },
  { name: "Instagram", Icon: Instagram, href: "#" },
  { name: "Twitter", Icon: Twitter, href: "#" },
];

export const Footer = () => (
  <footer className="pt-20 pb-10 border-t border-[#2B2B26]/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-16">
        <div>
          <div className="flex items-center gap-2.5 mb-4 text-[#2B2B26]">
            <SunMark className="text-[#D7263D]" />
            <span className="font-serif text-2xl text-[#1877F2]">My Life</span>
          </div>
          <p className="font-body text-[#2B2B26]/60 max-w-xs leading-relaxed">
            Your gentle daily companion for your day, health, and plans.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <a
            data-testid="footer-email"
            href="mailto:info@mylifeorg.tech"
            className="group inline-flex items-center gap-2 font-body text-[#2B2B26]/80 hover:text-[#2B2B26] transition-colors"
          >
            <Mail className="w-4 h-4 text-[#1877F2]" strokeWidth={1.5} />
            info@mylifeorg.tech
          </a>
          <a
            data-testid="footer-domain"
            href="https://mylifeorg.tech"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 font-body text-[#2B2B26]/80 hover:text-[#2B2B26] transition-colors"
          >
            <Globe className="w-4 h-4 text-[#1877F2]" strokeWidth={1.5} />
            mylifeorg.tech
          </a>

          {/* Social links (functional in the future) */}
          <div className="flex items-center gap-3 mt-3" data-testid="footer-socials">
            {socials.map(({ name, Icon, href }) => (
              <a
                key={name}
                data-testid={`footer-social-${name.toLowerCase()}`}
                href={href}
                aria-label={name}
                className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2B2B26]/15 text-[#2B2B26]/70 transition-all duration-300 hover:bg-[#1877F2] hover:border-[#1877F2] hover:text-[#F8F7F1] hover:-translate-y-0.5"
              >
                <Icon className="w-4 h-4" strokeWidth={1.6} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Massive wordmark */}
      <div className="overflow-hidden">
        <h2 className="font-serif font-light text-[#1877F2] leading-none tracking-tight text-[22vw] md:text-[18vw] text-center select-none">
          My Life
        </h2>
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[#2B2B26]/50 font-body text-xs">
        <span>© {new Date().getFullYear()} My Life · Wellness Hub. All rights reserved.</span>
        <span className="uppercase tracking-[0.2em]">Made gently.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
